/**
 * projects
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 999.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */



export interface ProjectsGetUserNamesRequest {
    /**
     * The list of projects. If not passed or empty then all the projects are searched
     */
    projects?: Array<string>;
    /**
     * If set to \'true\' and the projects field is not empty then the result includes   user name from the subprojects children
     */
    include_subprojects?: boolean;
    /**
     * The type of the child entity to look for
     */
    entity?: ProjectsGetUserNamesRequest.EntityEnum;
}
export namespace ProjectsGetUserNamesRequest {
    export type EntityEnum = 'task' | 'model' | 'dataview';
    export const EntityEnum = {
        Task: 'task' as EntityEnum,
        Model: 'model' as EntityEnum,
        Dataview: 'dataview' as EntityEnum
    }
}
